<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { schoolSettingsApi } from '@/api/schoolSettings';

const router = useRouter();

const message = ref('Die App ist aktuell im Wartungsmodus. Bitte später erneut versuchen.');
const checking = ref(false);

let timer = null;

async function checkIfMaintenanceEnded() {
  checking.value = true;
  try {
    const resp = await schoolSettingsApi.getCurrent();
    const data = resp?.data || {};
    const enabled = Boolean(data.appMaintenanceEnabled ?? data.app_maintenance_enabled ?? false);

    if (!enabled) {
      try {
        localStorage.removeItem('app_maintenance');
        localStorage.removeItem('app_maintenance_message');
      } catch (e) {
        /* no-op */
      }
      router.replace('/');
    }
  } catch (e) {
    // Wenn weiterhin Wartung aktiv ist oder API blockiert → einfach stehen bleiben
  } finally {
    checking.value = false;
  }
}

onMounted(() => {
  try {
    const storedMsg = localStorage.getItem('app_maintenance_message');
    if (storedMsg && storedMsg.trim() !== '') message.value = storedMsg;
  } catch (e) {
    /* no-op */
  }

  checkIfMaintenanceEnded();
  timer = window.setInterval(checkIfMaintenanceEnded, 30000);
});

onBeforeUnmount(() => {
  if (timer) window.clearInterval(timer);
});
</script>

<template>
  <main
    class="page"
    role="main"
    aria-labelledby="page-title"
  >
    <header class="page-header">
      <h1
        id="page-title"
        class="h1"
      >
        Wartungsarbeiten
      </h1>
    </header>

    <section class="card">
      <p
        class="notice"
        role="status"
      >
        {{ message }}
      </p>

      <p class="help mt-12">
        Diese Seite aktualisiert den Status automatisch.
      </p>

      <div
        class="mt-12"
        style="display: flex; gap: 8px; justify-content: flex-end;"
      >
        <button
          class="btn btn-primary"
          type="button"
          :disabled="checking"
          @click="checkIfMaintenanceEnded"
        >
          {{ checking ? 'Prüfe…' : 'Erneut prüfen' }}
        </button>
      </div>
    </section>
  </main>
</template>
